export default function ModalFechas({ equipo, fechas, onClose }) {
  if (!equipo) return null;

  const formatear = (fecha) => {
    if (!fecha) return '—';
    return new Date(fecha).toLocaleDateString('es-MX', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  };

  return (
  <div className="overlay" onClick={onClose}>
    <div className="modal" onClick={e => e.stopPropagation()}
      style={{ width: 520, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
      
      {/* Header fijo */}
      <h3 style={{ marginTop: 0, flexShrink: 0 }}>
        Historial de fechas — {equipo.marca} {equipo.modelo}
      </h3>

      {/* Contenido con scroll */}
      <div style={{ overflowY: 'auto', flex: 1 }}>
        {!fechas || fechas.length === 0 ? (
          <p style={{ color: '#888' }}>Sin historial de cambios</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead style={{ position: 'sticky', top: 0 }}>
              <tr style={{ background: '#1e6378', color: 'white' }}>
                <th style={{ padding: '8px', textAlign: 'left' }}>Fecha cambio</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Valor anterior</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Valor nuevo</th>
              </tr>
            </thead>
            <tbody>
              {fechas.map((f, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '8px' }}>{formatear(f.fecha_cambio)}</td>
                  <td style={{ padding: '8px', color: '#dc3545' }}>{f.valor_anterior ?? '—'}</td>
                  <td style={{ padding: '8px', color: '#28a745' }}>{f.valor_nuevo ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Footer fijo */}
      <div style={{ textAlign: 'right', marginTop: 16, flexShrink: 0 }}>
        <button className="btn-secondary" onClick={onClose}>Cerrar</button>
      </div>
    </div>
  </div>
);
}